import { Injectable, inject } from '@angular/core';
import {
  ICreateDesconto,
  IUpdateDesconto,
  TipoDesconto,
} from '@nomoh-monorepo/shared-types';
import { DescontosDataService } from './feature-descontos.dataservice.service';

@Injectable({ providedIn: 'root' })
export class DescontosService {
  private descontosDataService = inject(DescontosDataService);

  // PRINCÍPIO KISS: Component injeta DataService diretamente para signals
  // Service apenas para business logic com validações

  async carregarDescontos(): Promise<void> {
    // Business logic: Validar permissão (quando disponível)
    // await this.permissionService.validarPermissao('descontos.read');

    return this.descontosDataService.carregarDescontos();
  }

  async buscarDescontos(
    descricao?: string,
    token?: string,
    tipo?: TipoDesconto
  ): Promise<void> {
    // await this.permissionService.validarPermissao('descontos.read');

    return this.descontosDataService.carregarDescontos({
      filtros: { descricao, token, tipo },
    });
  }

  async criarDesconto(desconto: ICreateDesconto): Promise<string> {
    // Business logic: Validar permissão crítica
    // await this.permissionService.validarPermissao('descontos.create');

    // Validações de negócio
    if (!desconto.descricao || desconto.descricao.trim().length === 0) {
      throw new Error('Descrição do desconto é obrigatória');
    }

    if (!desconto.token || desconto.token.trim().length === 0) {
      throw new Error('Token do cupom é obrigatório');
    }

    if (!desconto.valor || desconto.valor <= 0) {
      throw new Error('Valor do desconto deve ser maior que zero');
    }

    if (desconto.tipo === 'PERCENTUAL' && desconto.valor > 100) {
      throw new Error('Desconto percentual não pode ser maior que 100%');
    }

    return this.descontosDataService.criar(desconto);
  }

  async atualizarDesconto(
    id: string,
    desconto: IUpdateDesconto
  ): Promise<void> {
    // await this.permissionService.validarPermissao('descontos.update');

    // Validações de negócio
    if (!id || id.trim().length === 0) {
      throw new Error('ID do desconto é inválido');
    }

    if (desconto.valor !== undefined && desconto.valor <= 0) {
      throw new Error('Valor do desconto deve ser maior que zero');
    }

    return this.descontosDataService.atualizar(id, desconto);
  }

  async excluirDesconto(id: string): Promise<void> {
    // await this.permissionService.validarPermissao('descontos.delete');

    // Validação de negócio
    if (!id || id.trim().length === 0) {
      throw new Error('ID do desconto é inválido');
    }

    // Confirmação adicional pode ser feita no componente
    return this.descontosDataService.deletar(id);
  }

  async buscarPorId(id: string): Promise<void> {
    // await this.permissionService.validarPermissao('descontos.read');

    if (!id || id.trim().length === 0) {
      throw new Error('ID do desconto é inválido');
    }

    return this.descontosDataService.buscarPorId(id);
  }

  // Métodos de navegação (sem validação adicional necessária)
  async proximaPagina(): Promise<void> {
    return this.descontosDataService.proximaPagina();
  }

  async paginaAnterior(): Promise<void> {
    return this.descontosDataService.paginaAnterior();
  }

  async irParaPagina(pagina: number): Promise<void> {
    return this.descontosDataService.irParaPagina(pagina);
  }

  async alterarTamanhoPagina(limit: number): Promise<void> {
    return this.descontosDataService.alterarTamanhoPagina(limit);
  }

  resetState(): void {
    return this.descontosDataService.resetState();
  }
}
